import { PROCEDURE_CONSTANTS_DETAILS } from "../constants";

const {
  PROCEDURE_CLASS_PATIENT_CASE_STUDY_DATE,
  PROCEDURE_CLASS_PATIENT_CASE_STUDY_DOCTOR_NOTES,
  LEGACY_PROCEDURE_CLASS_PATIENT_CASE_STUDY_DATE,
  LEGACY_PROCEDURE_CLASS_PATIENT_CASE_STUDY_NOTES,
} = PROCEDURE_CONSTANTS_DETAILS;

export const CASE_STUDY_CONTENT_FORMAT = "quill-delta";

// Accept both current and earlier database class names during migration.
export const isCaseStudyDateClass = (className) =>
  className === PROCEDURE_CLASS_PATIENT_CASE_STUDY_DATE ||
  className === LEGACY_PROCEDURE_CLASS_PATIENT_CASE_STUDY_DATE;

export const isCaseStudyNotesClass = (className) =>
  className === PROCEDURE_CLASS_PATIENT_CASE_STUDY_DOCTOR_NOTES ||
  className === LEGACY_PROCEDURE_CLASS_PATIENT_CASE_STUDY_NOTES;

export const createCaseStudyData = ({
  date,
  notes,
  doctorName,
}) => ({
  date,
  contentFormat: CASE_STUDY_CONTENT_FORMAT,
  notes,
  updatedBy: {
    name: doctorName,
  },
});

export const stringifyCaseStudyData = (data) =>
  JSON.stringify(data);

export const parseCaseStudyData = (
  value,
  legacyFallback = "",
) => {
  if (!value) {
    return {};
  }

  try {
    const parsedValue = JSON.parse(value);

    return typeof parsedValue === "object" &&
      parsedValue !== null
      ? parsedValue
      : {};
  } catch (error) {
    return {
      contentFormat: "legacy-text",
      notes: legacyFallback || value,
    };
  }
};
